import React from 'react';

import { KonvaCanvas, type KonvaCanvasProps } from './KonvaCanvas';

/**
 * Thin wrapper kept here so `ImageLab.tsx` continues to import a stable
 * `CanvasSlot` symbol while F11b/F11c flesh out the canvas surface (mask,
 * sketch, reference, grid, selection). The wrapper exists to give those
 * future layer-aware features a single mount point with the same prop
 * shape — adding layers won't ripple into the shell.
 */
export const CanvasSlot: React.FC<KonvaCanvasProps> = props => <KonvaCanvas {...props} />;
